import { apiCallback } from 'api';

const definition = {
  service: 'account',
  endpoint: 'accounts/reset-requests',
  query: {
    clientType: 'WEB_APP',
  },
  verbs: ['post'],
  defaultVersion: 1,
};

export default {
  post: apiCallback(definition, 'post'),
};
